module.exports = __webpack_public_path__ + "static/media/profile.52422fc6.jpg";